import { render, staticRenderFns } from "./ProductStandard1.vue?vue&type=template&id=1d15e925&scoped=true"
import script from "./ProductStandard1.vue?vue&type=script&lang=js"
export * from "./ProductStandard1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d15e925",
  null
  
)

export default component.exports